import React from "react";

import PageHeading from "../../components/page-heading";
import useCompatNavigate from "../../hooks/use-compat-navigate";

const HomeScreen = () => {
  const compatNavigate = useCompatNavigate();
  return (
    <>
      <PageHeading title="Página principal Encuestas DAI ULAGOS" />

      <div className="card text-center mt-2 bg-primary">
        <div className="card-body">
          <h1 className="card-title text-white">Encuesta juicio expertos</h1>
          <br />
          <button
            className="btn btn-danger btn-lg"
            onClick={() => compatNavigate("/encuestas/encuesta-juicio-expertos/splash")}
          >
            ABRIR SPLASH PAGE ENCUESTA
          </button>
        </div>
      </div>

      {/* {[...Array(100)].map((e) => (
        <h1>HOLA A TODOS</h1>
      ))} */}
    </>
  );
};

export default HomeScreen;
